import classNames from "classnames";

import { BoldText } from "components/BoldText/BoldText";
import { BaseLayout } from "components/BaseLayout/BaseLayout";

import styles from "./styles.module.scss";
import { ClientsFooter, ClientsBody } from "./components";

const Header = (): JSX.Element => (
  <BoldText className={styles.groupTitle}>Клиенты</BoldText>
);

export const Clients = (): JSX.Element => (
  <BaseLayout
    className={classNames("ml-2 mt-3 mb-3", styles.container)}
    header={<Header />}
    footer={<ClientsFooter />}
  >
    <ClientsBody />
  </BaseLayout>
);
